import { useCallback } from 'react';
import { Intervention } from '@/types';
import {
  useGetAllScenariosQuery,
  useLazyGetScenarioQuery,
  useSaveScenarioMutation,
} from '@/api/scenarios';
import { identify } from '@/data/identify';

// Data layer for the "copy intervention to scenario" feature. Lives in a hook
// (not the component) so the API calls stay out of ./src/components and the two
// call sites (scenario sidebar + scenario assumptions) share one implementation.
const useCopyIntervention = () => {
  const { data: scenarios = [] } = useGetAllScenariosQuery();
  const [getScenario] = useLazyGetScenarioQuery();
  const [saveScenario] = useSaveScenarioMutation();

  const copyIntervention = useCallback(
    async (targetScenarioId: number, intervention: Intervention) => {
      const target = await getScenario(targetScenarioId).unwrap();
      const copied = identify({ ...intervention, id: undefined });
      await saveScenario({
        ...target,
        interventions: [...target.interventions, copied],
      }).unwrap();
    },
    [getScenario, saveScenario],
  );

  return { scenarios, copyIntervention };
};

export { useCopyIntervention };
